<template>
  <ContentWrap>
    <!-- <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="分类下挂方案入口；点击一律走跳转链接。四大业务线驱动 /portal/solutions 筛选项与导航下拉。"
    /> -->
    <el-form :inline="true" class="-mb-10px" @submit.prevent>
      <el-form-item label="所属分类">
        <el-select
          v-model="queryParams.tabKey"
          clearable
          placeholder="全部"
          class="!w-200px"
          @change="handleQuery"
        >
          <el-option
            v-for="tab in tabOptions"
            :key="tab.tabKey"
            :label="`${tab.name} (${tab.tabKey})`"
            :value="tab.tabKey"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="标题">
        <el-input
          v-model="queryParams.title"
          clearable
          class="!w-200px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button v-hasPermi="['portal:solution:create']" @click="openForm('create')">
          新增入口
        </el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="list" border class="mt-12px">
      <el-table-column label="标题" prop="title" min-width="160" show-overflow-tooltip />
      <el-table-column label="短名" prop="shortName" min-width="100" />
      <el-table-column label="分类" prop="tabKey" width="120" align="center" />
      <el-table-column label="行业筛" prop="industry" width="100" />
      <el-table-column label="跳转链接" prop="linkUrl" min-width="160" show-overflow-tooltip />
      <el-table-column label="推荐" width="70" align="center">
        <template #default="{ row }">
          <el-tag :type="row.recommend ? 'success' : 'info'" size="small">
            {{ row.recommend ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort" width="70" align="center" />
      <el-table-column label="状态" width="90" align="center">
        <template #default="{ row }">
          <el-tag v-if="row.status === 1" type="success">发布</el-tag>
          <el-tag v-else type="info">未发布</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button
            v-hasPermi="['portal:solution:update']"
            link
            type="primary"
            @click="openForm('update', row)"
          >
            编辑
          </el-button>
          <el-button
            v-hasPermi="['portal:solution:delete']"
            link
            type="danger"
            @click="handleDelete(row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="total"
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      @pagination="getList"
    />
  </ContentWrap>

  <el-dialog v-model="dialogVisible" :title="dialogTitle" width="640px" destroy-on-close>
    <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="所属分类" prop="tabKey">
        <el-select v-model="form.tabKey" class="!w-full" filterable>
          <el-option
            v-for="tab in tabOptions"
            :key="tab.tabKey"
            :label="`${tab.name} (${tab.tabKey})`"
            :value="tab.tabKey"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="全称" prop="title">
        <el-input v-model="form.title" />
      </el-form-item>
      <el-form-item label="短名" prop="shortName">
        <el-input v-model="form.shortName" />
      </el-form-item>
      <el-form-item label="摘要">
        <el-input v-model="form.summary" type="textarea" :rows="2" />
      </el-form-item>
      <el-form-item label="效果句">
        <el-input v-model="form.effect" />
      </el-form-item>
      <el-form-item v-if="form.tabKey === 'industry' || form.tabKey === 'industry-suite'" label="行业筛">
        <el-input v-model="form.industry" placeholder="列表页顶部筛选项，如：电器行业" />
      </el-form-item>
      <el-form-item label="跳转链接" prop="linkUrl">
        <el-input v-model="form.linkUrl" placeholder="如 /portal/solutions/retail 或 https://..." />
      </el-form-item>
      <el-form-item label="能力标签">
        <el-select
          v-model="form.productList"
          multiple
          filterable
          allow-create
          default-first-option
          class="!w-full"
          placeholder="输入后回车添加"
        />
      </el-form-item>
      <el-form-item label="中栏图标">
        <UploadImg v-model="form.icon" :limit="1" directory="portal/solution/icon" height="80px" />
        <div class="text-12px text-gray-400 mt-4px">仅 Mega 导航中栏小方块；不要当封面用</div>
      </el-form-item>
      <el-form-item label="封面图">
        <UploadImg v-model="form.coverImage" :limit="1" directory="portal/solution" />
        <div class="text-12px text-gray-400 mt-4px">列表卡顶区整块铺满 / Mega 右侧 / 首页卡</div>
      </el-form-item>
      <el-form-item label="推荐">
        <el-switch v-model="form.recommend" />
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.sort" :min="0" :max="9999" />
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :value="1">发布</el-radio>
          <el-radio :value="0">草稿</el-radio>
          <el-radio :value="2">下线</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="formLoading" @click="submitForm">保存</el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { ElMessageBox } from 'element-plus'
import type { FormInstance, FormRules } from 'element-plus'
import { UploadImg } from '@/components/UploadFile'
import * as Api from '@/api/system/portal-solution'
import { useMessage } from '@/hooks/web/useMessage'

defineOptions({ name: 'PortalSolutionEntry' })

const message = useMessage()
const loading = ref(false)
const list = ref<Api.PortalSolutionEntryVO[]>([])
const total = ref(0)
const tabOptions = ref<Api.PortalSolutionTabVO[]>([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  tabKey: '' as string | undefined,
  title: '' as string | undefined
})
const dialogVisible = ref(false)
const dialogTitle = ref('')
const formType = ref<'create' | 'update'>('create')
const formLoading = ref(false)
const formRef = ref<FormInstance>()
const editingId = ref<number>()
/** 编辑时保留原 slug，运营不可见 */
const editingSlug = ref('')

function isIconImageUrl(value?: string) {
  const v = String(value || '').trim()
  if (!v) return false
  return (
    /^https?:\/\//i.test(v) ||
    v.startsWith('/') ||
    v.startsWith('data:image/') ||
    /\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(v)
  )
}

const form = reactive({
  tabKey: 'industry',
  title: '',
  shortName: '',
  summary: '',
  effect: '',
  industry: '',
  linkUrl: '',
  productList: [] as string[],
  icon: '',
  coverImage: '',
  recommend: false,
  sort: 100,
  status: 1
})

const rules: FormRules = {
  tabKey: [{ required: true, message: '请选择分类', trigger: 'change' }],
  title: [{ required: true, message: '请输入全称', trigger: 'blur' }],
  shortName: [{ required: true, message: '请输入短名', trigger: 'blur' }],
  linkUrl: [{ required: true, message: '请输入跳转链接', trigger: 'blur' }]
}

function parseProducts(raw?: string) {
  if (!raw) return [] as string[]
  try {
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr.map(String) : []
  } catch {
    return []
  }
}

async function loadTabs() {
  const data = await Api.getPortalSolutionTabPage({ pageNo: 1, pageSize: 100 })
  tabOptions.value = (data.list || []).sort((a, b) => (b.sort || 0) - (a.sort || 0))
}

async function getList() {
  loading.value = true
  try {
    const data = await Api.getPortalSolutionEntryPage({
      pageNo: queryParams.pageNo,
      pageSize: queryParams.pageSize,
      tabKey: queryParams.tabKey || undefined,
      title: queryParams.title || undefined
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

function handleQuery() {
  queryParams.pageNo = 1
  getList()
}

function defaultTabKey() {
  return (
    queryParams.tabKey ||
    tabOptions.value.find((t) => t.tabKey === 'industry')?.tabKey ||
    tabOptions.value[0]?.tabKey ||
    'industry'
  )
}

function openForm(type: 'create' | 'update', row?: Api.PortalSolutionEntryVO) {
  formType.value = type
  dialogTitle.value = type === 'create' ? '新增方案入口' : '编辑方案入口'
  editingId.value = row?.id
  if (row) {
    form.tabKey = row.tabKey
    form.title = row.title
    form.shortName = row.shortName
    form.summary = row.summary || ''
    form.effect = row.effect || ''
    form.industry = row.industry || ''
    form.linkUrl = row.linkUrl || ''
    form.productList = parseProducts(row.products)
    form.icon = isIconImageUrl(row.icon) ? row.icon || '' : ''
    form.coverImage = row.coverImage || ''
    form.recommend = !!row.recommend
    form.sort = row.sort ?? 100
    form.status = row.status ?? 1
    editingSlug.value = row.slug || ''
  } else {
    Object.assign(form, {
      tabKey: defaultTabKey(),
      title: '',
      shortName: '',
      summary: '',
      effect: '',
      industry: '',
      linkUrl: '',
      productList: [],
      icon: '',
      coverImage: '',
      recommend: false,
      sort: 100,
      status: 1
    })
    editingSlug.value = ''
  }
  dialogVisible.value = true
}

async function submitForm() {
  await formRef.value?.validate()
  formLoading.value = true
  try {
    const payload: Api.PortalSolutionEntryVO = {
      id: editingId.value,
      tabKey: form.tabKey,
      title: form.title,
      shortName: form.shortName,
      summary: form.summary,
      effect: form.effect,
      industry:
        form.tabKey === 'industry' || form.tabKey === 'industry-suite'
          ? form.industry || form.shortName
          : undefined,
      slug: editingSlug.value || undefined,
      linkUrl: form.linkUrl.trim(),
      icon: form.icon || undefined,
      coverImage: form.coverImage,
      products: JSON.stringify(form.productList || []),
      recommend: form.recommend,
      sort: form.sort,
      status: form.status
    }
    if (formType.value === 'create') {
      delete payload.id
      await Api.createPortalSolutionEntry(payload)
      message.success('已创建')
    } else {
      await Api.updatePortalSolutionEntry(payload)
      message.success('已保存')
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

async function handleDelete(id?: number) {
  if (!id) return
  await ElMessageBox.confirm('确认删除该入口？', '提示', { type: 'warning' })
  await Api.deletePortalSolutionEntry(id)
  message.success('已删除')
  await getList()
}

onMounted(async () => {
  await loadTabs()
  await getList()
})
</script>
